/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type LabelDropdownJSQueryVariables = {
    taskId?: string | null | undefined;
};
export type LabelDropdownJSQueryResponse = {
    readonly viewer: {
        readonly component: string | null;
        readonly company: {
            readonly availableMLModels: {
                readonly labelModel: boolean | null;
            } | null;
        } | null;
        readonly task: {
            readonly labelSuggestion: ReadonlyArray<string | null> | null;
        } | null;
    } | null;
};
export type LabelDropdownJSQuery = {
    readonly response: LabelDropdownJSQueryResponse;
    readonly variables: LabelDropdownJSQueryVariables;
};



/*
query LabelDropdownJSQuery(
  $taskId: ID
) {
  viewer {
    component(name: "suggested_label_dropdown")
    company {
      availableMLModels {
        labelModel
      }
      id
    }
    task(id: $taskId) {
      labelSuggestion
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId",
    "type": "ID"
  }
],
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "suggested_label_dropdown"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"suggested_label_dropdown\")"
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "AvailableMLModels",
  "kind": "LinkedField",
  "name": "availableMLModels",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "labelModel",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "taskId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "labelSuggestion",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LabelDropdownJSQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LabelDropdownJSQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v3/*: any*/),
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "LabelDropdownJSQuery",
    "operationKind": "query",
    "text": "query LabelDropdownJSQuery(\n  $taskId: ID\n) {\n  viewer {\n    component(name: \"suggested_label_dropdown\")\n    company {\n      availableMLModels {\n        labelModel\n      }\n      id\n    }\n    task(id: $taskId) {\n      labelSuggestion\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '1e7937b7557a43cb2e3e717b48d74d61';
export default node;
